import React from "react";
import { ButtonPink } from "../../../components/Button";
import styled from "styled-components";
import giftIcon from "../../../assets/images/gift-icon.png";

const DustAmountBtn = styled(ButtonPink)`
  height: auto;
  font-family: Poppins;
  font-weight: 600;
  padding: 0em 0em 0em 0em;
  font-size: 1em;
  border-radius: 0.6rem;
  background-color: #000;
  min-width: unset;
  opacity: 1;
  text-align: center;
  min-width: 2.4em;
  transition: opacity 0.4s ease-in-out, background-color 0.4s ease-in-out;
  z-index: 11;

  &:hover {
    background-color: #f51cdd;
  }
`;

const Icon = styled.img`
  height: 1.6em;
`;

const DustAmountEmbedButton = ({ className, amount, onClick }) => {
  return (
    <DustAmountBtn className={className} onClick={onClick}>
      <Icon src={giftIcon} />
    </DustAmountBtn>
  );
};

export default DustAmountEmbedButton;
